import React, { Fragment } from 'react';
import useCalendarState from './useCalendarState.jsx';
import MonthViewCalendar from './MonthViewCalendar.jsx';
import {
  Menu,
  Dropdown,
  Button,
  Segment,
  Dimmer,
  Loader,
} from 'semantic-ui-react';

const defaultDate = new Date();

export default function PaymentDeviceStatusHistory({
  fetchPath,
  date = defaultDate,
  maxDateValue = defaultDate,
  minDateValue = defaultDate,
}) {
  const {
    calendarState,
    handleMonthChange,
    handleNextClick,
    handlePreviousClick,
    getDateActivities,
    monthOptions,
  } = useCalendarState({
    fetchPath,
    date,
    maxDateProp: maxDateValue,
    minDateProp: minDateValue,
  });

  return (
    <Fragment>
      <Menu
        fluid
        secondary
        widths={3}
      >
        <Menu.Item fitted>
          <Button
            primary
            content='Previous Month'
            disabled={!calendarState.hasPreviousMonth}
            icon='chevron left'
            labelPosition='left'
            onClick={handlePreviousClick}
          />
        </Menu.Item>
        <Menu.Item fitted>
          <Dropdown
            search
            selection
            options={monthOptions}
            value={calendarState.currentDate.getTime().toString()}
            onChange={(e, { value }) => handleMonthChange(value)}
          />
        </Menu.Item>
        <Menu.Item fitted>
          <Button
            primary
            content='Next Month'
            disabled={!calendarState.hasNextMonth}
            icon='chevron right'
            labelPosition='right'
            onClick={handleNextClick}
          />
        </Menu.Item>
      </Menu>

      <Dimmer.Dimmable
        vertical
        as={Segment}
        dimmed={calendarState.isLoading}
      >
        <Dimmer
          inverted
          active={calendarState.isLoading}
        >
          <Loader size='medium'>Loading</Loader>
        </Dimmer>
        {calendarState.isLoading ? (
          <Segment />
        ) : (
          <MonthViewCalendar
            footerContent={calendarState.statusSummary}
            getDateActivities={getDateActivities}
            selectedDate={calendarState.currentDate}
          />
        )}
      </Dimmer.Dimmable>
    </Fragment>
  );
}
